const rootActionPath = 'core/forYou';

export const BECAUSE_YOU_SHOPPED_VIEW = `${rootActionPath}/BecauseYouShopped/VIEW`;

export const TERMS_AND_CONDITIONS_CLICK = `${rootActionPath}/termsAndConditions/CLICK`;

export const CURRENT_BONUS_OFFERS_VIEW = `${rootActionPath}/CurrentBonusOffers/VIEW`;
export const PENDING_BONUS_OFFERS_VIEW = `${rootActionPath}/PendingBonusOffers/VIEW`;
